'use memo';

import { useState, useEffect } from 'react';
import { AdditionalDocumentations } from './types';
import {
  AgxSpacer,
  AgxTypography,
  AgxWaiverOfCoolingOff,
  AgxYesNoQuestion,
  YesNo,
} from '@urbanx/agx.ui-components2';

interface AdditionalDocumentationsProps {
  id: string;
  onValueChanged: (value: { id: string; value: AdditionalDocumentations }) => void;
  defaultValue: AdditionalDocumentations;
  validate?: boolean;
}

const AdditionalDocumentationsComponent = ({
  id,
  defaultValue,
  onValueChanged,
  validate,
}: AdditionalDocumentationsProps) => {
  const [additionalDocumentations, setadditionalDocumentations] = useState({
    isMultipleOfferForm: defaultValue?.isMultipleOfferForm ?? false,
    waiverOfCoolingOff: defaultValue?.waiverOfCoolingOff,
  });

  useEffect(() => {
    onValueChanged({
      id,
      value: {
        ...additionalDocumentations,
      },
    });
  }, [additionalDocumentations]);

  return (
    <AgxSpacer direction="vertical" gap="spacing-4xl" fill>
      <AgxTypography id={`${id}-additional-forms-label`} type="label" size="large">
        Additional forms
      </AgxTypography>
      <AgxSpacer direction="vertical" gap="spacing-md" fill>
        <AgxYesNoQuestion
          id="multipleofferform"
          key="multipleofferform"
          onValueChanged={(value) =>
            setadditionalDocumentations({
              ...additionalDocumentations,
              isMultipleOfferForm: value.value === YesNo.Yes ? true : false,
            })
          }
          defaultValue={additionalDocumentations.isMultipleOfferForm ? YesNo.Yes : YesNo.No}
          label="Multiple offer form"
          reverseLabelOrder
          noLabel="Not required"
          yesLabel="Yes, include Multiple offer form"
        />
      </AgxSpacer>
      <AgxWaiverOfCoolingOff
        key="WaiverOfCoolingOff"
        id="WaiverOfCoolingOff"
        onValueChanged={(value) =>
          setadditionalDocumentations({
            ...additionalDocumentations,
            waiverOfCoolingOff: value,
          })
        }
        defaultValue={additionalDocumentations.waiverOfCoolingOff}
        validate={validate}
      />
    </AgxSpacer>
  );
};

export default AdditionalDocumentationsComponent;
